export const LOGIN = '@@session/LOGIN';
export const LOGOUT = '@@session/LOGOUT';
